import * as yup from "yup";
import i18next from "i18next";

export const stringNullable = (text) => yup.string().nullable();
export const stringRequired = (text) =>
  yup
    .string()
    .required(() => text ?? i18next.t("VALIDATION_ERROR_REQUIRED_FIELD"))
    .trim();

export const stringNullableRequired = (text) =>
  yup
    .string()
    .required(() => text ?? i18next.t("VALIDATION_ERROR_REQUIRED_FIELD"))
    .nullable();

export const url = () =>
  yup
    .string()
    .matches(
      /^((ft|htt)ps?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%@_.~+&:]*)*(\?[;&a-z\d%@_.,~+&:=-]*)?(#[-a-z\d_]*)?$/i,
      i18next.t("VALIDATION_ERROR_VALID_URL")
    )
    .trim();

export const emailRequired = (text) =>
  yup
    .string()
    .email(i18next.t("VALIDATION_ERROR_VALID_EMAIL"))
    .required(() => text ?? i18next.t("VALIDATION_ERROR_REQUIRED_FIELD"))
    .trim();

export const emailNullable = () =>
  yup
    .string()
    .email(() => i18next.t("VALIDATION_ERROR_VALID_EMAIL"))
    .nullable()
    .trim();

export const numberNatural = (text) =>
  yup
    .number()
    .required(() => text ?? i18next.t("VALIDATION_ERROR_REQUIRED_FIELD"))
    .positive(() => text ?? i18next.t("VALIDATION_ERROR_VALID_NUMBER_POSITIVE"))
    .round("trunc");
